import { parseCompetitorVariable } from '@/dashboards/CompetitorsMediaInvestment/helpers/parseCompetitorVariable';

export const getCategoriesFromCompetitorVariables = (
    competitorVariables: string[],
) =>
    competitorVariables.reduce(
        (acc: string[], variableName: string): string[] => {
            const parsed = parseCompetitorVariable(variableName);
            if (!parsed) {
                return acc;
            }

            if (!acc.includes(parsed.channel)) {
                acc.push(parsed.channel);
            }

            return acc;
        },
        [],
    );
